
import {Container} from 'semantic-ui-react'
import AccountOnboarding from "xAppLib/UIelems/AccountOnboarding";
import MFA from "xAppLib/UIelems/MFA";
import MessageBar from "xAppLib/UIelems/MessageBar";
import {CouldNotCallConsults} from "../../views/instcons/CouldNotCallConsults";
import PatientAppointments from "../../views/booking/PatientAppointments";
import Prescs from "../../views/prescs/Prescs";
import {InProgressVideoConsults} from "../../views/instcons/InProgressVideoConsults";
import {PrivacyAlert} from 'xAppLib/UIelems/PrivacyAlert';
import {UserHasCreditsAlert} from 'xAppLib/UIelems/UserHasCreditsAlert';
import {PRIVACY_VERSION} from "@iscr/views/content/Privacy";

const CommonAlerts = () => {
    const user = app.user.prof
    const code = user?.healthcredits?.code || '';

    const health_credits = user?.healthcredits?.amount || 0
    return (
        <>
            <MessageBar hide_on={[app.runtime?.login_type == 'popup' && 'user_auth_msg']} />
            {!app.settings.iscr2 && <AccountOnboarding />}
            <MFA bannerMode />
            {!app.acl.is_blocked && <>
                <Container className="!p-0 space-y-4 my-4 empty:my-0">
                    {(app?.acl?.is_usr && !app?.settings?.icosm && !app.site_status?.notifications?.enable_banners?.includes?.(app.runtime?.app)) ? (
                        <>
                            <CouldNotCallConsults />
                            <PatientAppointments />
                            <Prescs />
                        </>
                    ) : null}
                    {!app.site_status?.notifications?.enable_banners?.includes?.(app.runtime?.app) && (
                        <InProgressVideoConsults />
                    )}
                </Container>
            </>}
            {user && app.acl.is_usr && user.meta?.privacy_version !== PRIVACY_VERSION && <PrivacyAlert />}
            {user && health_credits > 0 && !user.meta?.dismissed_credit_alerts?.includes(code) && <UserHasCreditsAlert />}
        </>
    );
};

export default CommonAlerts;
